// ** React Imports
import { Fragment } from 'react'

// ** Routes Imports
import UserRoutes from './farm/pages/User'
// import AdminRoutes from './kaska/pages/Admin'

// KASKA
import AuthenticationRoutes from './farm/pages/Authentication'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'
import VerticalLayout from '@src/layouts/VerticalLayout'
import HorizontalLayout from '@src/layouts/HorizontalLayout'
import LayoutWrapper from '@src/@core/layouts/components/layout-wrapper'

// ** Route Components
import PublicRoute from './farm/components/PublicRoute'
import PrivateRoute from './farm/components/PrivateRoute'

// ** Utils
import { isObjEmpty } from '@utils'
// import FrontendLayout from '../../layouts/FrontendLayout'

const getLayout = {
  // frontend: <FrontendLayout />,
  blank: <BlankLayout />,
  vertical: <VerticalLayout />,
  horizontal: <HorizontalLayout />
}

// ** Document title
const TemplateTitle = '%s - Farmer'

// ** Default Route
const DefaultRoute = '/farms'
const AdminDefaultRoute = '/users'

// ** Merge Routes
const Routes = [
  // ...FrontendRoutes,
  ...AuthenticationRoutes,
  ...UserRoutes
  // ...AdminRoutes
]

const getRouteMeta = route => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta }
    } else {
      return {}
    }
  }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = []

  if (Routes) {
    Routes.filter(route => {
      let isBlank = false
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) && defaultLayout === layout)
      ) {
        let RouteTag = PrivateRoute

        // ** Check for public or private route
        if (route.meta) {
          // route.meta.layout === 'blank' || route.meta.layout === 'frontend' ? (isBlank = true) : (isBlank = false)
          route.meta.layout === 'blank' ? (isBlank = true) : (isBlank = false)
          RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            isObjEmpty(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
                LayoutWrapper
              : Fragment

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          )
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route)
      }
      return LayoutRoutes
    })
  }
  return LayoutRoutes
}

const getRoutes = layout => {
  const defaultLayout = layout || 'vertical'
  // const layouts = ['vertical', 'horizontal', 'blank', 'frontend']
  const layouts = ['vertical', 'horizontal', 'blank']

  const AllRoutes = []

  layouts.forEach(layoutItem => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

    AllRoutes.push({
      path: '/',
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    })
  })
  return AllRoutes
}

// export { DefaultRoute, AdminDefaultRoute, TemplateTitle, Routes, getRoutes }
export { DefaultRoute, AdminDefaultRoute, TemplateTitle, Routes, getRoutes }
